class CtaCircle {
    constructor(el) {
        this.textEl = null;
        this.rotation = 0;
        this.lastScrollY = 0;
        this.rafId = null;
        this.speed = 0.15;
        this.el = el;
        this.init();
    }
    init() {
        this.textEl = this.el.querySelector(".cta-circle__text");
        if (!this.textEl) {
            return;
        }
        this.lastScrollY = window.scrollY;
        window.addEventListener("scroll", this.onScroll.bind(this), { passive: true });
    }
    onScroll() {
        if (this.rafId !== null) {
            return;
        }
        this.rafId = requestAnimationFrame(() => {
            const delta = window.scrollY - this.lastScrollY;
            this.lastScrollY = window.scrollY;
            this.rotation -= delta * this.speed;
            this.textEl.style.transform = `rotate(${this.rotation}deg)`;
            this.rafId = null;
        });
    }
}
export default CtaCircle;
